import { __awaiter } from "tslib";
import log from 'pathfinder/utils/log';
export const fetchRecentlyUpdatedArticles = () => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield fetch('/wikia.php?controller=FancentralApi&method=getRecentlyUpdatedPages');
        if (response.ok) {
            return (yield response.json());
        }
        else {
            log.debug(`Couldn't return data. Response.ok: ${response.ok} | Response.status: ${response.status}`);
            return;
        }
    }
    catch (error) {
        log.error('Error on get Fancentral API: getRecentlyUpdatedPages', error);
        return;
    }
});
